import { Controller } from 'stimulus';
import hasHistorySupport from '../helpers/hasHistorySupport';
import toArray from '../helpers/toArray';

function updateUrl(url) {
  if (hasHistorySupport()) {
    window.history.replaceState(null, null, url);
  }
}

function getProductVariantHtml(url) {
  return $.ajax({
    url,
  });
}

function outputProductVariant(html) {
  const $blocksToReplace = $(html).find('[data-replace-id]');

  if ($blocksToReplace.length) {
    $blocksToReplace.toArray().forEach((block) => {
      const replaceId = block.getAttribute('data-replace-id');
      const replaceElement = document.querySelector(`[data-replace-id="${replaceId}"]`);

      if (replaceElement) {
        replaceElement.innerHTML = block.innerHTML;
      }
    });
  }
}

class VariantSelect extends Controller {
  onVariantSelect(event) { // eslint-disable-line class-methods-use-this
    const selectBox = event.target;
    const selectedOptionIndex = selectBox.selectedIndex;
    const selectedOption = toArray(selectBox.querySelectorAll('option'))[selectedOptionIndex];

    const productUrl = selectedOption.getAttribute('data-product-url');

    updateUrl(productUrl);

    getProductVariantHtml(productUrl)
      .then(outputProductVariant);
  }
}

VariantSelect.targets = [
  //
];

export default VariantSelect;
